import {sortBy} from 'lodash';

export function sortByBooleanMap<ItemType, KeyType>(
  items: ReadonlyArray<ItemType>,
  booleanMap: Map<KeyType, boolean>,
  computeKey: (object: ItemType) => KeyType,
  {isTrueFirst = true}: {isTrueFirst?: boolean} = {},
): ReadonlyArray<ItemType> {
  return sortBy(items, (item) => {
    const value = booleanMap.get(computeKey(item)) ?? false;
    return isTrueFirst ? !value : value;
  });
}
